import { useNavigate } from "react-router-dom"
import './index.scss'

import chevronLeft from 'url:@icon/chevron.left.svg';
import Dropdown, { DropdownItem, DropdownProps } from "@components/Dropdown";

interface HeaderLink {
  icon?: any
  title: string
  onClick: () => void
}

export default function PageHeader(props: {
  title: string,
  subtitle?: string,
  links?: HeaderLink[],
  backLocation?: string,
  showBackButton?: boolean,
  dropdown?: DropdownProps
}) {
  const navigate = useNavigate();

  return <div className="page-header">
    <div className="content">
      {props.showBackButton === undefined || props.showBackButton === true ?
        <a className="back" href="#back" onClick={() => navigate(props.backLocation ?? "/")}><img className="icon" src={chevronLeft} alt="Left arrow icon" /> Back</a> :
        null}

      <h1 className="header-title">{props.title}</h1>
      {props.subtitle !== undefined ? <h2 className="header-subtitle">{props.subtitle}</h2> : null}
      {props.links !== undefined ? <div className="header-links">
        {props.links.map((link) => {
          return <a href={link.title}
            key={link.title}
            onClick={(e) => {
              e.preventDefault();
              link.onClick();
            }}>
            {link.icon !== undefined ? <img src={link.icon} alt={`${link.title} icon`} /> : null}{link.title}
          </a>
        })}
      </div> : null}
    </div>

    {props.dropdown && <Dropdown {...props.dropdown} />}
  </div>
}